
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://yswvnptgkifohjacvqdv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inlzd3ZucHRna2lmb2hqYWN2cWR2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEwMTMxODYsImV4cCI6MjA1NjU4OTE4Nn0.ubh4QJLn0oYowf1e-znfH-iIidNf9TghqxtbKFWUE-4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Create only ONE instance of the client to prevent duplication warnings
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

// Set up auth state change listener - useful for debugging auth issues
supabase.auth.onAuthStateChange((event, session) => {
  console.log(`Auth state changed: ${event}`, session ? `User: ${session.user?.email} (${session.user?.id})` : 'No session');
});
